import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.93 16.13L11.48 17.5L6 11.75L11.48 6L12.93 7.37L8.76 11.75L12.93 16.13ZM16.55 17.5L18 16.13L13.83 11.75L18 7.37L16.55 6L11.07 11.75L16.55 17.5Z" fill={ fill || 'currentColor' } />
    </svg>
);
